export default "__VITE_ASSET__kXhaOeJa5Bqdy9ACgCD_Pg__"